import { DialogTitle, DialogContent, Typography, DialogActions, Button } from "@mui/material";
import { renderClose } from "../../common/dialog";
import { renderListStore } from "../../common/listStoreUi";
import { createListStore } from "../../common/listStore";
import { UseEntityStore } from "../../common/entityStore";
import { TmOrderDto } from "./common";
import { map } from "rxjs";
import { useState } from "react";
import { useCustomerStates } from "../../common/enum";
import { getResource } from "../../common/localization";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui.Customer." + key, defaultMessage) as string;
}

export function DuplicateCustomersResolveDialog(props: {
    close(): void;
    useStore: UseEntityStore<TmOrderDto>;
}) {
    const [useStore] = useState(() => createListStore({
        data: props.useStore.getState().clientData$.pipe(map(p => ({ items: p.data.duplicateCustomers ?? [], isFetching: false }))),
        getId: p => p.customerId!,
        listProps: [
            { column: "custId", label: getText("CustId"), width: 80 },
            { column: "fname", label: getText("FirstName"), width: 80 },
            { column: "lname", label: getText("LastName"), width: 120 },
            { column: "strt1", label: getText("Strt1"), width: 150 },
            { column: "strt2", label: getText("Strt2"), width: 80 },
            { column: "zipCode", label: getText("ZipCode"), width: 80 },
            { column: "city", label: getText("City"), width: 150 },
            { column: "tel", label: getText("Tel"), width: 125 },
            { column: "mob", label: getText("Mob"), width: 125 },
            { column: "email", label: getText("Email"), width: 200 },
            { column: "customerStateId", label: getText("Status"), width: 150, enumStore: useCustomerStates },
        ],
    }));
    const selectedCustomer = useStore(p => p.selectedItem);
    function loadCustomer(custId: string) {
        props.useStore.getState().setClientDataProp("custId", custId);
        props.close();
    }
    return <>
        <DialogTitle>{getText("ExistingCustomers")}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Typography mb={4}>

            </Typography>
            {renderListStore(useStore, {
                onDoubleClick(item) {
                    loadCustomer(item.custId);
                }
            })}
        </DialogContent>
        <DialogActions>
            <Button disabled={selectedCustomer == null} onClick={() => {
                loadCustomer(selectedCustomer!.custId);
            }} color="positive">{getText("LoadSelectedCustomer")}</Button>
            <Button onClick={() => {
                props.useStore.getState().setClientDataProp("duplicateCustomers", []);
                props.close();
            }} color="warning">{getText("CreateNewCustomer")}</Button>
            <Button onClick={props.close} color="negative" variant="outlined">{getResource("Ui.Cancel")}</Button>
        </DialogActions>
    </>;
}
